function getHeroVideo() {
    return document.querySelector('#hero-video video');
}

function playHeroVideo() {
    const video = getHeroVideo();

    if (!video) {
        return;
    }

    video.muted = true;
    const playAttempt = video.play();

    if (playAttempt && typeof playAttempt.catch === 'function') {
        playAttempt.catch(() => {
            // Autoplay may still be blocked by browser policy.
        });
    }
}

function holdHeroVideoUntilReady() {
    const video = getHeroVideo();

    if (!video) {
        return;
    }

    video.removeAttribute('autoplay');
    video.pause();
    video.currentTime = 0;
}

function watchHomeLoaderThenPlay(loader) {
    const observer = new MutationObserver(() => {
        if (loader.classList.contains('is-dismissing') || !loader.isConnected) {
            observer.disconnect();
            playHeroVideo();
        }
    });

    observer.observe(loader, {
        attributes: true,
        attributeFilter: ['class'],
    });

    observer.observe(loader.parentNode || document.body, {
        childList: true,
    });
}

function initHomeHeroVideo() {
    const video = getHeroVideo();

    if (!video) {
        return;
    }

    const loader = document.querySelector('.kronos-home-loader');

    if (!loader) {
        playHeroVideo();
        return;
    }

    holdHeroVideoUntilReady();
    watchHomeLoaderThenPlay(loader);
}

document.addEventListener('DOMContentLoaded', initHomeHeroVideo);
